import React from 'react';
import { useSelectContext } from './SelectContext';
import { cn } from '../../utils';

interface SelectItemProps {
  value: string;
  children: React.ReactNode;
}

export const SelectItem: React.FC<SelectItemProps> = ({ value, children }) => {
  const {
    onChange,
    setIsOpen,
    optionsMap,
    value: selectedValue,
  } = useSelectContext();

  const optionsLabel = optionsMap?.[value];
  const isSelected = value === selectedValue;

  const handleClick = () => {
    onChange(value, optionsLabel);
    setIsOpen(false);
  };

  return (
    <div
      className={cn(
        'text-[#4D4E58] hover:bg-[#E4E4E4] p-2 cursor-pointer first-of-type:rounded-t-lg last-of-type:rounded-b-lg',
        {
          'bg-[#4D4E58] hover:bg-[#4D4E58] text-[#FFF]': isSelected,
        },
      )}
      onClick={handleClick}
      role="option"
      aria-selected={isSelected}
    >
      {children}
    </div>
  );
};
